import styled from 'styled-components';
import {SendQuestion} from '../send-question/send-question';
import {FindAnotherOrder} from '../find-another-order/find-another-order';
import {useContext} from 'react';
import {InitializeParamsContext} from '../../store/context/context';

const Wrapper = styled.div`
    max-width: 570px;
    margin: 60px 0 100px;
`;

const Text = styled.div`
    line-height: 1.6;
    margin-bottom: 22px;
`;

const Buttons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const InfoBlock = () => {
    const infoText = useContext(InitializeParamsContext).infoText;

    return (
        <Wrapper>
            <b>ВЫДАЧА ЗАКАЗОВ</b>
            <Text dangerouslySetInnerHTML={{__html: decodeURIComponent(escape(atob(infoText)))}} />
            <Buttons>
                <SendQuestion />
                <FindAnotherOrder />
            </Buttons>
        </Wrapper>
    );
};

export {InfoBlock};
